import React from 'react';
import Navbar from '../../components/general/Navbar';
import Home from '../../components/general/Home';
import Footer from '../../components/general/Footer';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <Home />
      <Footer />
    </>
  )
}

export default HomePage;